<template>
  <nav class="absolute top-0 left-0 right-0 w-full p-4 md:p-8 z-50 md:bg-white lg:bg-transparent  lg:shadow-none  md:shadow-lg shadow-lg shadow-gray-300 antialiased">
    <div class="flex items-center justify-between px-4 md:px-6">

      <!-- Logo -->
      <div class="flex items-center">
        <img src="@/assets/logo phisoft.png" alt="Logo" class="h-16 w-auto" />
      </div>

      <!-- Menu (Desktop) -->
      <ul class="lg:hidden hidden xl:flex items-center space-x-16 text-white text-2xl">
        <li>
          <router-link to="/" class="hover:text-teal-500 transition">Home</router-link>
        </li>
        <li>
          <router-link to="/about" class="hover:text-teal-500 transition">About Us</router-link>
        </li>
        <li>
          <a href="https://phisoft.co.id/blog/" class="hover:text-teal-500 transition">
            Blog
          </a>
        </li>
        <li>
          <router-link to="/contact" class="hover:text-teal-500 transition">Contact</router-link>
        </li>
      </ul>

      <!-- Hamburger Button (Mobile) -->
      <button @click="toggleMenu" class=" xl:hidden text-gray-500 focus:outline-none">
        <i v-if="!isMenuOpen" class="fas fa-bars text-2xl"></i>
        <i v-else class="fas fa-times text-2xl"></i>
      </button>
    </div>

    <!-- Mobile Menu -->
    <div :class="isMenuOpen ? 'translate-x-0' : 'translate-x-full'"
     class="fixed right-0 top-0 h-full w-64 bg-white shadow-lg transition-transform duration-300 ease-in-out z-40">
  
  <!-- Tombol Close -->
  <button class="absolute top-4 right-4 text-3xl text-black" @click="isMenuOpen = false">
    <i class="fas fa-times"></i>
  </button>

  <!-- Menu List -->
  <ul class="flex flex-col items-center pt-20 space-y-6 py-6 px-6 text-gray-800 text-xl">
    <li>
      <router-link to="/" class="hover:text-blue-500 transition" @click="closeMenu">Home</router-link>
    </li>
    <li>
      <router-link to="/about" class="hover:text-blue-500 transition" @click="closeMenu">About Us</router-link>
    </li>
    <li>
      <a 
        href="https://phisoft.co.id/blog/" 
        class="hover:text-blue-500 transition"
        @click="closeMenu"
      >
        Blog
      </a>
    </li>
    <li>
      <router-link to="/contact" class="hover:text-blue-500 transition" @click="closeMenu">Contact</router-link>
    </li>
  </ul>
</div>
  </nav>

</template>

<script>
export default {
  data() {
    return {
      isMenuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
  },
};
</script>
